window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.tooltip').length) {
    import('./_tooltip.js').then((module) => {
      module.Init();
    });
  }
});
  
export default {};